import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useTheme } from '../context/ThemeContext';

const ContactThanks: React.FC = () => {
  const { colors, dsColors } = useTheme();

  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.background }}>
      <main className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-20">
        <div
          className="p-8 sm:p-10 rounded-2xl border text-center"
          style={{ borderColor: colors.border, backgroundColor: colors.surface }}
        >
          <div
            className="w-14 h-14 mx-auto mb-5 rounded-full flex items-center justify-center"
            style={{ backgroundColor: `${dsColors.successStrong}26` }}
          >
            <svg className="w-7 h-7" style={{ color: dsColors.successStrong }} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: colors.textPrimary, textWrap: 'balance' }}>
            Message sent
          </h1>
          <p className="mb-4 text-sm" style={{ color: colors.textSecondary }}>
            Thanks for reaching out. We&apos;ve received your message and will get back to you as soon as we can
            at the email address you provided.
          </p>
          <p className="mb-7 text-xs" style={{ color: colors.textTertiary }}>
            For urgent safety issues, please contact local emergency services directly.
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="inline-flex items-center px-4 py-2 rounded-md text-sm font-semibold transition focus:outline-none focus-visible:ring-2"
              style={{
                backgroundColor: colors.surface,
                color: colors.textPrimary,
                border: `1px solid ${colors.border}`,
                '--tw-ring-color': dsColors.primary,
              } as React.CSSProperties}
            >
              Back to home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center px-4 py-2 rounded-md text-sm font-semibold shadow-sm hover:shadow-md transition focus:outline-none focus-visible:ring-2"
              style={{
                backgroundColor: dsColors.primaryStrong,
                color: '#ffffff',
                '--tw-ring-color': dsColors.primary,
              } as React.CSSProperties}
            >
              Send another message
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactThanks;
